@if (customerCount() > 1 && session()?.role !== 'USER') {
  <mat-form-field class="d-block" subscriptSizing="dynamic">
    <mat-label>Search customers</mat-label>
    <input type="text" matInput name="searchCustomers" [(ngModel)]="searchTerm" [matAutocomplete]="auto" />
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="selectCustomer($event)">
      @for (customer of filteredCustomers(); track customer.customerProfileId) {
        <mat-option [value]="customer">
          {{ customer.name }}
          <span class="mat-body-small text-body-tertiary">
            {{ customer.customerNbrs.length > 1 ? 'All' : customer.customerNbrs[0] }}
          </span>
        </mat-option>
      }
    </mat-autocomplete>
    @if (searchTerm()) {
      <button matSuffix matIconButton (click)="searchTerm.set('')">
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>
} @else {
  <div class="py-2 ps-3 border-start">{{ session()?.customerName }}</div>
}
